import { zoom } from "./zoom_v2.js";
import { identityService } from "./profile/identityService_v2.js";
import { matchService } from "./matches/matchService_v2.js";
import { profile } from "./profile/profile_v2.js";
import { dasModal } from "./modal_v2.js";
import { createAccount } from "./profile/createAccount_v2.js";
import { eventHub } from "./eventHub_v2.js";
import { iPop } from "./ipop_v2.js";
import { colors } from "./colors_v2.js";
import { join } from "./matches/join_v2.js";
import { leaderboard } from "./leaderboard_v2.js";
import { help } from "./help_v2.js";
import { newMatch } from "./matches/newMatch_v2.js";
import { recentMatches } from "./matches/recentMatches_v2.js";
import { currentMatch } from "./matches/currentMatch_v2.js";

const routerState = {
  urlJoinCode: "",
  urlMatchID: "",
};

const renderURLJoinPop = () => {
  const html = `
  <div class="max">
  <div id="howJoinContainer">
    How would you like to join?
    <div id="urlJoinPop">
      <button class="urlJionButton" id="urlJoinLogIn">Log In</button>
      <button class="urlJionButton" id="urlJoinCreate">Create Account</button>
      <div id="joinTempRow">
        <div>
          <button class="urlJionButton" id="urlJoinAsTemp">Join Without an Account</button>
        </div>
          <div id="urlJoinWOSplainer" class="i">ⓘ</div>
      </div>
      </div>
  </div>
  </div>
  `;
  dasModal.render(html);
  colors.setButtonColors;
};

const handleJoinAsTemp = async () => {
  dasModal.close();
  const urlJoinCode = router.getURLJoinCode();
  if (urlJoinCode.length > 0) {
    const joinResult = await join.joinByURL(urlJoinCode);
    if (joinResult.status != 200) {
      return;
    }
  }
};

const handleUrlJoinLogIn = () => {
  dasModal.close();
  profile.render("normal");
};

const urlJoinCreate = () => {
  dasModal.close();
  createAccount.render();
};

const renderurlJoinWOSplainer = (event) => {
  const text = `Join using a temporary identity`;
  iPop.render({
    text,
    event,
  });
};

const parseURLJoinCode = (url) => {
  const joinCode = url.search.slice(1);
  const result = matchService.isJoinCodeValid(joinCode);
  if (result.status === 200) {
    result.urlJoinCode = joinCode;
  } else {
    result.urlJoinCode = "";
  }
  return result;
};

const getURLPathname = (url) => {
  let pathname = url.pathname;
  // /login, /login/, /LOGIN etc
  if (pathname.endsWith("/") && pathname.length > 1) {
    pathname = pathname.slice(0, -1);
  }
  return pathname;
};

const renderCodeNotValidPop = () => {
  dasModal.close();
  dasModal.render(`<div class=max>The URL join code is not valid</div>`);
};

const route = async () => {
  const playerOne = await identityService.createIdentity({
    name: "Player One",
    type: "temp",
  });
  document.getElementById("loadingSubRight").innerHTML = `      
      <br />
      <h2>A Game of Hexagons</h2>
      <br />`;
  const url = new URL(window.location.href);
  switch (getURLPathname(url)) {
    case "/":
      await identityService.setPlayingAs({
        name: playerOne.identity.name,
        createMatch: true,
      });
      document.getElementById("loading").style.display = "none";
      dasModal.render(`
        <div id="notLoggedInWelcome">
        <br>
        <div class="popHeader">Welcome!</div>
        <p>
          How to play:
          <div class="left">
          <ol>
            <li>Add pieces on top of existing pieces or in the middle. 
              <ul><li>The underneath piece tries to move out of the way</li></ul>
            <li>Rotate or Remove pieces</li>
            <li>One point for each side your pieces share with each other</li>
          </ol>
          <ul>
            <li>Learn more in Help</li>
            <li>Log in to enable history, leaderboards, etc.</li>
          </ul>
          </div>
        </p>
        </div>
        `);
      break;
    case "/login":
      await identityService.setPlayingAs({
        name: playerOne.identity.name,
        createMatch: false,
      });

      zoom.resizeCanvas();
      profile.render("normal");
      document.getElementById("loading").style.display = "none";
      break;
    case "/leaderboard":
      await identityService.setPlayingAs({
        name: playerOne.identity.name,
        createMatch: false,
      });

      zoom.resizeCanvas();
      leaderboard.render("normal");
      document.getElementById("loading").style.display = "none";
      break;
    case "/help":
      await identityService.setPlayingAs({
        name: playerOne.identity.name,
        createMatch: false,
      });

      zoom.resizeCanvas();
      help.render("normal");
      document.getElementById("loading").style.display = "none";
      break;
    case "/new":
      await identityService.setPlayingAs({
        name: playerOne.identity.name,
        createMatch: false,
      });

      zoom.resizeCanvas();
      newMatch.render("normal");
      document.getElementById("loading").style.display = "none";
      break;
    case "/recent":
      await identityService.setPlayingAs({
        name: playerOne.identity.name,
        createMatch: false,
      });

      zoom.resizeCanvas();
      recentMatches.render("normal");
      document.getElementById("loading").style.display = "none";
      break;
    case "/current":
      await identityService.setPlayingAs({
        name: playerOne.identity.name,
        createMatch: false,
      });

      zoom.resizeCanvas();
      currentMatch.render("normal");
      document.getElementById("loading").style.display = "none";
      break;
    case "/profile":
      await identityService.setPlayingAs({
        name: playerOne.identity.name,
        createMatch: false,
      });

      zoom.resizeCanvas();
      profile.render("normal");
      document.getElementById("loading").style.display = "none";
      break;
    case "/join":
      await identityService.setPlayingAs({
        name: playerOne.identity.name,
        createMatch: false,
      });
      const rawSearch = url.search;
      if (rawSearch.length > 0) {
        const result = parseURLJoinCode(url);
        if (result.status === 200) {
          routerState.urlJoinCode = result.urlJoinCode;
          await renderURLJoinPop();
        } else {
          join.render("normal");
        }
      } else {
        join.render("normal");
      }
      zoom.resizeCanvas();
      document.getElementById("loading").style.display = "none";
      break;
    default:
      await identityService.setPlayingAs({
        name: playerOne.identity.name,
        createMatch: true,
      });
      document.getElementById("loading").style.display = "none";
      break;
  }
};

const getURLJoinCode = () => {
  return routerState.urlJoinCode;
};

const clearURLJoinCode = () => {
  routerState.urlJoinCode = "";
};

const getURLMatchID = () => {
  return routerState.urlMatchID;
};

const clearURLMatchID = () => {
  routerState.urlMatchID = "";
};

eventHub.registerEvent("click", "urlJoinWOSplainer", renderurlJoinWOSplainer);
eventHub.registerEvent("click", "urlJoinLogIn", handleUrlJoinLogIn);
eventHub.registerEvent("click", "urlJoinCreate", urlJoinCreate);
eventHub.registerEvent("click", "urlJoinAsTemp", handleJoinAsTemp);

export const router = {
  route,
  getURLJoinCode,
  clearURLJoinCode,
  getURLMatchID,
  clearURLMatchID,
};
